import { NgModule } from '@angular/core';
import { SharedModule } from '@mp-shared/shared.module';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [],
  imports: [
    SharedModule,
    HttpClientModule,
  ],
  exports: []
})
export class CoreModule {
}
